var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"last:mb-0"},[(_vm.toggled)?_vm._t("default"):_c('p',{staticClass:"cursor-pointer",on:{"click":() => (_vm.toggled = true)}},[_vm._v(" "+_vm._s(_vm.toggleText)+" ")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }